import { dropDown } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

// Interface for full Xero department data with worktype mapping
export interface XeroDepartmentFull {
  id?: number
  Id?: number  // Some APIs use PascalCase
  name?: string
  Name?: string
  worktypeId?: number
  WorktypeId?: number  // Some APIs use PascalCase
  // Add other fields as needed based on the API response
}

// Xero Departments (full data with worktype mapping)
export const getXeroDepartments = async (): Promise<XeroDepartmentFull[]> => {
  const token = localStorage.getItem('authToken')
  const response = await fetch(`https://${apiURL}/xerotrackingdepartment`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch Xero departments')
  }
  
  const data = await response.json()
  console.log('Raw Xero Departments full data:', data)
  console.log('Data type:', typeof data)
  console.log('Is array:', Array.isArray(data))
  console.log('Data length:', data?.length)
  console.log('Sample Xero department:', data?.[0])
  
  // Ensure we return an array
  if (!Array.isArray(data)) {
    console.warn('API returned non-array data:', data)
    return []
  }
  
  return data
}

// Xero Departments
export const getXeroDepartmentsDropdown = async (): Promise<dropDown[]> => {
  const token = localStorage.getItem('authToken')
  const response = await fetch(`https://${apiURL}/xerotrackingdepartment/fordropdown`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch Xero departments')
  }
  
  const data = await response.json()
  console.log('Raw Xero Departments data:', data)
  return data.map((item: any) => {
    const numericValue = Number(item.value)
    return {
      text: item.text || 'Unknown',
      value: isNaN(numericValue) ? 0 : numericValue
    }
  })
}

// Xero Accounts
export const getXeroAccountsDropdown = async (): Promise<dropDown[]> => {
  const token = localStorage.getItem('authToken')
  const response = await fetch(`https://${apiURL}/xeroaccount`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch Xero accounts')
  }
  
  const data = await response.json()
  console.log('Raw Xero Accounts data:', data)
  return data.map((item: any) => {
    const numericValue = Number(item.xeroAccountId)
    return {
      text: item.description || 'Unknown',
      value: isNaN(numericValue) ? 0 : numericValue
    }
  })
}

// Xero Tax Rates
export const getXeroTaxRatesDropdown = async (): Promise<dropDown[]> => {
  const token = localStorage.getItem('authToken')
  const response = await fetch(`https://${apiURL}/xerotaxrate/expensefordropdown`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch Xero tax rates')
  }
  
  const data = await response.json()
  console.log('Raw Xero Tax Rates data:', data)
  return data.map((item: any) => {
    const numericValue = Number(item.value)
    return {
      text: item.text || 'Unknown',
      value: isNaN(numericValue) ? 0 : numericValue
    }
  })
}

// Xero Types (might be document types or transaction types)
export const getXeroTypesDropdown = async (): Promise<dropDown[]> => {
  const token = localStorage.getItem('authToken')
  const response = await fetch(`https://${apiURL}/xerotrackingtype/fordropdown`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch Xero types')
  }
  
  const data = await response.json()
  console.log('Raw Xero Types data:', data)
  return data.map((item: any) => {
    const numericValue = Number(item.value)
    return {
      text: item.text || 'Unknown',
      value: isNaN(numericValue) ? 0 : numericValue
    }
  })
}

// Xero Suppliers
export const getXeroSuppliersDropdown = async (): Promise<dropDown[]> => {
  const token = localStorage.getItem('authToken')
  const response = await fetch(`https://${apiURL}/xerosupplier`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch Xero suppliers')
  }
  
  const data = await response.json()
  console.log('Raw Xero Suppliers data:', data)
  return data.map((item: any) => {
    const numericValue = Number(item.xeroSupplierId)
    return {
      text: item.name || 'Unknown',
      value: isNaN(numericValue) ? 0 : numericValue
    }
  })
}